import React, { useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import Html from 'react-pdf-html';
const styles = StyleSheet.create({
  page: {
    backgroundColor: '#FFFFFF',
    padding: '30px 30px 30px 30px',
  },
  header: {
    fontSize: 18,
    marginBottom: 10,
    textAlign: 'center',
  },
  content: {
    fontSize: 12,
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 20,
    right: 20,
    textAlign: 'center',
    fontSize: 12,
  },
  pageHeader: {
    textAlign: 'left',
    fontSize: 12,
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 15,
  },
  pageHeaderCompanyName: {
    width: '50%',
    color: '#4A4845',
  },
  pageHeaderOrganization: {
    width: '50%',
    textAlign: 'right',
    color: '#757575',
  },
  pageFooter: {
    position: 'absolute',
    bottom: 20,
    left: 20,
    right: 20,
    textAlign: 'left',
    fontSize: 12,
    display: 'flex',
    flexDirection: 'row',
  },
  pageFooterRevisionDate: {
    width: '50%',
    color: '#757575',
  },
  pageFooterPageNumber: {
    width: '50%',
    textAlign: 'right',
    color: '#757575',
  },
  coverPageContent: {
    height: '80%',
    width: '100%',
    minHeight: '80%',
    maxWidth: '100%',
    wordBreak: 'break-all',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  coverPageContentCompanyName: {
    width: '95%',
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'center',
    flexWrap: 'wrap',
    color: '#319119',
    fontSize: '32px',
    fontWeight: 'ultrabold',
    marginBottom: '30px',
    wordBreak: 'break-word !important'
  },
  coverPageContentOrganization: {
    fontSize: '24px',
    fontWeight: 'extrabold',
    marginBottom: '10px',
    color: '#4A4845',
  },
  coverPageContentRevisionDate: {
    color: '#4A4845',
    fontSize: '12px',
  },
  sectionTitle: {
    color: '#003E69',
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  paragraph: {
    color: '#4A4845',
    fontSize: '12px',
    marginBottom: '10px',
    lineHeight: 1.3,
    display: 'flex',
    flexWrap: 'wrap',
  },
  logo: {
    width: 200,
    height: 200
  }
});

// Function to render PDF content
const renderPDFContent = (content) => {
  const stylesheet = {
    body: {
      fontFamily: 'Helvetica',
    },
    p: {
      fontSize: '12px',
      lineHeight: 1.5,
      fontWeight: 400,
      color: '#4A4845',
      textAlign: 'justify',
      marginBottom: '-10px',
      'li > &': {
        marginTop: '5px',
      },
    },
    h1: {
      fontSize: '24px',
      fontWeight: 'ultrabold',
      marginBottom: '-15px',
      color: '#003E69',
    },
    h2: {
      fontSize: '20px',
      lineHeight: 1.23,
      fontWeight: 700,
      color: '#003E69',
      marginBottom: '-12px',
    },
    h3: {
      fontSize: '17px',
      fontWeight: 700,
      color: '#4A4845',
      marginBottom: '-10px',
    },
    h4: {
      fontSize: '16px',
      marginBottom: '-12px',
    },
    h5: {
      fontSize: '14px',
      marginBottom: '-12px',
    },
    h6: {
      fontSize: '14px',
      marginBottom: '-12px',
    },
    ul: {
      fontSize: '12px',
      fontWeight: 400,
      color: '#4A4845',
      width: '90%',
      textAlign: 'justify',
      paddingLeft: '0px',
      marginBottom: '-5px'
    },
    ol: {
      fontSize: '12px',
      fontWeight: 400,
      color: '#4A4845',
      width: '90%',
    },
    li: {
      marginBottom: '7px',
    },
    b: {
      fontWeight: 'extrabold',
      color: '#4A4845',
    },
    'img.image64': {
      width: '90px',
    },
    '.description-content-renderer img': {
      display: 'inline-block',
      maxWidth: '100%',
      marginRight: '10px',
    },
    '.imageWithText': {
      marginTop: '24px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontSize: '12px',
      fontWeight: 'ultrabold !important',
      lineHeight: 1.25,
      letterSpacing: 0,
      textAlign: 'left',
      maxWidth: '76%',
      gap: '10px',
      wordWrap: 'break-word',
    },
    '.imageWithText .image64': {
      width: '70px',
      marginRight: '9px',
    },
    '.imageWithDescription': {
      marginTop: '15px',
      display: 'flex',
      flexDirection: 'row',
      fontSize: '12px',
      fontWeight: 'ultrabold !important',
      lineHeight: 1.25,
      letterSpacing: 0,
      textAlign: 'left',
      maxWidth: "85%"
    },

    '.section-pointer-text-wrapper': {
      wordWrap: 'break-word',
    },

    '.section-pointer-img--wrapper': {
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      width: 'auto',
      position: 'relative',
    },
    '.imageWithDescription .image64': {
      width: '50px',
      margin: '20px 25px 0px 0px',
    },
    '.description-section': {
      wordWrap: 'break-word',
    },
    '.group-images-container': {
      marginTop: '15px'
    },
    '.sub-group-images-container': {
      display: 'flex',
      flexWrap: 'wrap',
      flexDirection: 'row',
      gap: '10px',
    },
    '.sub-group-images-container .chemical-hazards-img': {
      width: '50px',
      marginLeft: '0px'
    },
    '.divider': {
      backgroundColor: '#5CB7E7',
      height: '1px',
      width: '100%',
      margin: '30px 0 0 0',
    },
    'li > p': {
      marginTop: '0px',
    },
    table: {
      margin: '20px 0'
    },
    tbody: {
      border: '0.5px solid black',
    },
    td: {
      fontSize: '12px',
      lineHeight: 1.5,
      fontWeight: 400,
      color: '#4A4845',
      textAlign: 'justify',
      border: '0.5px solid black',
      padding: '5px'
    },
  };
  const html = ReactDOMServer.renderToStaticMarkup(content);
  return <Html stylesheet={stylesheet}>{html}</Html>;
};


const PdfContent = ({ pdfContent, revisionDate, businessName, imageUrl }) => {
  const [pdf, setPdf] = useState([]);
  const renderIntroPage = () => {
    return (<Page size="A4" style={styles.page}>
      <View style={styles.pageHeader} fixed>
        <Text style={styles.pageHeaderCompanyName}>{businessName}</Text>
        <Text style={styles.pageHeaderOrganization}>Employee Health & Safety Handbook</Text>
      </View>
      <View style={styles.coverPageContent}>
        {imageUrl && <Image src={imageUrl} style={styles.logo} />}
        <Text style={styles.coverPageContentCompanyName}>{businessName}</Text>
        <Text style={styles.coverPageContentOrganization}>Employee Health & Safety Handbook</Text>
        <Text style={styles.coverPageContentRevisionDate}>Revision Date: {revisionDate}</Text>
      </View>
      <View style={styles.pageFooter}>
        <Text
          style={styles.pageFooterPageNumber}
          render={({ pageNumber }) => `Page: ${pageNumber}`}
        />
      </View>
    </Page>)
  }

  const renderSignoffPage = () => {
    return (<Page size="A4" style={styles.page}>
      <View style={styles.pageHeader} fixed>
        <Text style={{ width: '50%' }}>{businessName}</Text>
        <Text style={{ width: '50%', textAlign: 'right', color: 'grey' }}>
          Employee Health & Safety Handbook
        </Text>
      </View>
      <View>
        <Text style={styles.sectionTitle}>Employee Handbook Sign-Off</Text>
        <Text style={styles.paragraph}>
          I acknowledge receipt of the {businessName} Occupational Health & Safety Employee Handbook
          on:
        </Text>

        <Text style={styles.paragraph}>______(Day)_________(Month),_______(Year)</Text>

        <Text style={styles.paragraph}>
          I have reviewed the Handbook in its entirety and understand my responsibilities as an
          employee for managing health and safety in the workplace. When necessary, I have asked
          my supervisor/manager for clarification of my roles and responsibilities.
        </Text>
        <Text style={styles.paragraph}>
          I acknowledge that workplace health and safety is a shared responsibility between
          employers, supervisors and employees and agree to adhere to all {businessName} policies,
          procedures and safe work practices.
        </Text>

        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            textAlign: 'left',
            fontSize: '12px',
            width: '100%',
            marginBottom: '30px',
          }}
        >
          <Text style={{ width: '50%' }}>Employee Name</Text>
          <Text style={{ width: '50%' }}>Position</Text>
        </View>

        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            textAlign: 'left',
            fontSize: '12px',
            width: '100%',
            marginBottom: '15px',
          }}
        >
          <Text style={{ width: '50%' }}>__________________________________</Text>
          <Text style={{ width: '50%' }}>__________________________________</Text>
        </View>

        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            textAlign: 'left',
            fontSize: '12px',
            width: '100%',
            marginBottom: '30px',
          }}
        >
          <Text style={{ width: '50%' }}>Employee Signature</Text>
          <Text style={{ width: '50%' }}>Date</Text>
        </View>

        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            textAlign: 'left',
            fontSize: '12px',
            width: '100%',
            marginBottom: '15px',
          }}
        >
          <Text style={{ width: '50%' }}>__________________________________</Text>
          <Text style={{ width: '50%' }}>__________________________________</Text>
        </View>

        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            textAlign: 'left',
            fontSize: '12px',
            width: '100%',
            marginBottom: '30px',
          }}
        >
          <Text style={{ width: '50%' }}>Manager/Supervisor Name</Text>
          <Text style={{ width: '50%' }}>Date</Text>
        </View>

        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            textAlign: 'left',
            fontSize: '12px',
            width: '100%',
            marginBottom: '15px',
          }}
        >
          <Text style={{ width: '50%' }}>__________________________________</Text>
          <Text style={{ width: '50%' }}>__________________________________</Text>
        </View>

        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            textAlign: 'left',
            fontSize: '12px',
            width: '100%',
            marginBottom: '30px',
          }}
        >
          <Text style={{ width: '50%' }}>Manager/Supervisor Signature</Text>
        </View>

        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            textAlign: 'left',
            fontSize: '12px',
            width: '100%',
            marginBottom: '30px',
          }}
        >
          <Text style={{ width: '50%' }}>__________________________________</Text>
        </View>

        <Text style={styles.paragraph}>Signed copy to be kept in employee file.</Text>
      </View>
      <View style={styles.pageFooter}>
        <Text
          style={{ width: '50%', textAlign: 'right', color: 'grey' }}
          render={({ pageNumber }) => `Page: ${pageNumber}`}
        />
      </View>
    </Page>)
  }
  useEffect(() => {
    setPdf(pdfContent);
  }, [pdfContent]);

  return (
    <Document>
      {renderIntroPage()}
      {pdfContent &&
        (Array.isArray(pdf) ? (
          pdf?.map((content, index) => (
            <Page key={index} size="A4" style={styles.page} >
              <View style={styles.pageHeader} fixed>
                <Text style={styles.pageHeaderCompanyName}>{businessName}</Text>
                <Text style={styles.pageHeaderOrganization}>Employee Health & Safety Handbook</Text>
              </View>
              <View>{renderPDFContent(content)}</View>
              <View style={styles.pageFooter} fixed>
                <Text
                  style={styles.pageFooterPageNumber}
                  render={({ pageNumber }) => `Page: ${pageNumber}`}
                />
              </View>
            </Page>
          ))
        ) : (
          <Page size="A4" style={styles.page}>
            <View style={styles.pageHeader} fixed>
              <Text style={styles.pageHeaderCompanyName}>{businessName}</Text>
              <Text style={styles.pageHeaderOrganization}>Employee Health & Safety Handbook</Text>
            </View>

            <View>{renderPDFContent(pdfContent)}</View>

            <View style={styles.pageFooter} fixed>
              <Text
                style={styles.pageFooterPageNumber}
                render={({ pageNumber }) => `Page: ${pageNumber}`}
              />
            </View>
          </Page>
        ))}

      {renderSignoffPage()}
    </Document>
  );
};

export default PdfContent;
